<template>
	<el-tooltip
		class="c-tooltip"
		:popper-class="`c-tooltip-popover ${popoverClass}`"
		:disabled="disabled"
		:placement="placement"
		ref="tooltipRef"
		v-bind="$attrs"
	>
		<div slot="content" v-html="content"></div>
		<slot></slot>
	</el-tooltip>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
const props = defineProps({
	content: { type: String, default: '' },
	placement: { type: String, default: 'top' },
	popoverClass: { type: String, default: '' },
});

const emit = defineEmits(['onOverflow']);

const tooltipRef = ref(null);
const disabled = ref(true);

const mouseenter = e => {
	disabled.value = true;
	const $el = tooltipRef.value?.$el;
	if (!$el) return;

	const element =
		$el.closest('.c-text-ellipsis') || $el.querySelector('*[ellipsis-text], *[class*="overflow-ellipsis-"]') || $el;

	// 单行、多行省略判定
	// 需要注意不同浏览器、系统在遇到小数时会有不一样的处理方式，所以需要一些阈值来兼容
	const threshold = 1.5;
	if (
		element.scrollWidth - element.clientWidth > threshold ||
		element.scrollHeight - element.clientHeight > threshold
	) {
		disabled.value = false;
	}

	emit('onOverflow', !disabled.value);
};

onMounted(() => {
	tooltipRef.value?.$el.addEventListener('mouseenter', mouseenter);
});

onBeforeUnmount(() => {
	tooltipRef.value?.$el.removeEventListener('mouseenter', mouseenter);
});
</script>

<style lang="less" scoped>
.c-tooltip-icon {
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}
</style>
<style lang="less">
.c-tooltip-popover {
	font-size: 14px;
}
</style>
